import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StarMoneyDataModule } from './star-money';


@NgModule({
    imports: [
        CommonModule,
        StarMoneyDataModule,
    ],
    providers: [],
})
export class CoreDataModule { }